<template>
  <div id="sidebar-menu" class="mt-4">
    <ul
      class="sidebar-links custom-scrollbar"
      id="myDIV"
      :style="
        [
          layoutobject
            ? layoutobject.includes('horizontal-wrapper')
              ? layout.settings.layout_type == 'rtl'
                ? { 'margin-right': margin + 'px' }
                : { 'margin-left': margin + 'px' }
              : { margin: '0px' }
            : { margin: '0px' },
        ]
      "
    >
      <!-- 菜單項循環 -->
      <li
        v-for="(menuItem, index) in filteredMenuItems"
        :key="index"
        class="sidebar-list"
        :class="{
          'sidebar-main-title': menuItem.type == 'headtitle',
          pined: menuItem.showPin,
          active: isMenuActive(menuItem) && !isChildActive(menuItem),
        }"
      >
        <!-- 菜單標題 (headtitle) -->
        <div v-if="menuItem.type == 'headtitle'">
          <h6 class="lan-1">{{ menuItem.headTitle1 }}</h6>
        </div>

        <!-- 標籤 (badge) -->
        <label
          :class="'badge badge-' + menuItem.badgeType"
          v-if="menuItem.badgeType"
          >{{ menuItem.badgeValue }}</label
        >

        <!-- 子菜單 -->
        <a
          href="javascript:void(0)"
          class="sidebar-link sidebar-title"
          v-if="menuItem.type == 'sub'"
          @click="setNavActive(menuItem, $event)"
        >
          <img
            v-if="menuItem.icon"
            :src="getIconPath(menuItem.icon)"
            :class="menuItem.icon"
            alt="icon"
          />
          <span>{{ $t(menuItem.title) }}</span>
          <!-- 若是新項目 -->
          <span v-if="menuItem.isnew" class="new-icon">
            <img src="@/assets/images/driver/new.png" class="new-icon" />
          </span>
          <div class="according-menu" v-if="menuItem.children">
            <!-- <i
              class="fa"
              :class="menuItem.active ? 'fa-chevron-down' : 'fa-chevron-right'"
              aria-hidden="true"
            ></i> -->
            <img 
              src="@/assets/images/icon/prev.png" 
              alt="prew" 
              :class="['prev-icon', { 'rotated': isMenuActive(menuItem) }]"
            >
          </div>
        </a>

        <!-- 單個菜單 (link) -->
        <router-link
          :to="menuItem.path"
          class="sidebar-link sidebar-title"
          v-if="menuItem.type == 'link'"
          @click="setNavActive(menuItem, $event)"
        >
          <img
            v-if="menuItem.icon"
            :src="getIconPath(menuItem.icon)"
            :class="menuItem.icon"
            alt="icon"
          />
          <span>{{ $t(menuItem.title) }}</span>
          <!-- 若是新項目 -->
          <span v-if="menuItem.isnew">
            <img src="@/assets/images/driver/new.png" class="new-icon" />
          </span>
        </router-link>

        <!-- 子菜單列表 -->
        <ul
          class="sidebar-submenu"
          v-if="menuItem.children"
          :class="{ 'menu-open': isMenuActive(menuItem) }"
          :style="{ display: isMenuActive(menuItem) ? '' : 'none' }"
        >
          <li
            v-for="(childrenItem, idx) in getVisibleChildren(menuItem)"
            :key="idx"
            :class="{ active: childrenItem.active }"
          >
            <router-link
              class="lan-4"
              :to="childrenItem.path"
              @click="setNavActive(childrenItem, $event)"
            >
              {{ childrenItem.title }}
              <!-- 若是新項目 -->
              <span v-if="childrenItem.isnew">
                <img src="@/assets/images/driver/new.png" class="new-icon" />
              </span>
              <i
                class="fa fa-angle-right pull-right mt-1"
                v-if="childrenItem.children"
              ></i>
            </router-link>
          </li>
        </ul>
      </li>

      <!-- 底部導航項 -->
      <div class="sidebar-bottom">
        <li v-if="isUser">
          <router-link to="/help" class="sidebar-link sidebar-title">
            <img class="help-icon me-2" src="@/assets/images/icon/help.png" />
            <span>Help</span>
          </router-link>
        </li>
        <li v-if="!isUser && hasSettingsPermission">
          <router-link to="/admin/settings" class="sidebar-link sidebar-title">
            <img
              class="help-icon me-2"
              src="@/assets/images/admin/logo/settings.png"
            />
            <span>Settings</span>
          </router-link>
        </li>
        <li>
          <a
            href="javascript:void(0)"
            @click="logout"
            class="sidebar-link sidebar-title"
          >
            <i class="icofont icofont-exit text-dark me-2 footer-icon"></i>
            <span>Log out</span>
          </a>
        </li>
      </div>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { layoutClasses } from '../../constants/layout';
import { usePermissionStore } from '@/store/admin/permission';
import { useRoleStore } from '@/store/admin/role';
import { useRoute } from 'vue-router';

export default {
  name: 'Navmenu',

  data() {
    return {
      layoutobj: {},
      margin: 0,
      permissionStore: usePermissionStore(),
      roleStore: useRoleStore(),
      route: useRoute()
    };
  },

  computed: {
    ...mapState({
      menuItems: (state) => state.menu.data,
      layout: (state) => state.layout.layout,
    }),

    // 取得使用者
    currentUser() {
      const isAdminRoute = this.$route.path.startsWith('/admin');
      if (isAdminRoute) {
        return JSON.parse(localStorage.getItem('Admin')); // 後台管理員
      } else {
        return JSON.parse(localStorage.getItem('Driver')); // 前台使用者
      }
    },

    // 根據使用者資料過濾菜單
    filteredMenuItems() {
      const user = this.currentUser;
      if (!user) {
        console.log('No current user found');
        return [];
      }

     

      // 定義路徑與權限的對應關係
      const pathToPermission = {
        '/admin/cash-payments': 'Payments & Transfers',
        '/admin/dashboard': 'Dashboard',
        '/admin/transactions': 'Transactions',
        '/admin/driver-profile': 'Driver profile',
        '/admin/subgroups': 'Subgroups',
        '/admin/terminal': 'Terminal',
        '/admin/terminal-performance': 'Terminal performance',
        '/admin/fees-charges': 'Fees & charges',
        '/admin/refunds': 'Refunds',
        '/admin/staff-members': 'Staff members',
        '/admin/fleet': 'Fleet',
        '/admin/settings': 'Settings',
        '/admin/role': 'Role',
        '/admin/card-application': 'Card',
        '/admin/card-management': 'Card',
        '/admin/card-performance': 'Card'
      };

      const filteredItems = this.menuItems.filter((menuItem) => {
          console.log('Checking menu item:', menuItem.title);
          
          // 1) 確認角色是否匹配
          const passRoleCheck = !menuItem.role || menuItem.role === user.role;
          if (!passRoleCheck) {
            console.log('Role check failed for:', menuItem.title);
            return false;
          }

          // 2) 只在 admin 角色時檢查權限
          if (user.role === 'admin') {
            // 如果是子選單，用不修改原始資料的方式檢查是否有可見的子項
            if (menuItem.children) {
              const visibleChildren = menuItem.children.filter(child => {
                const permission = pathToPermission[child.path];
                if (permission) {
                  const hasPermission = this.permissionStore.hasPermission(permission);
                  console.log(`Permission check for ${child.title}: ${permission} - ${hasPermission}`);
                  return hasPermission;
                }
                return true;
              });
              if (visibleChildren.length === 0) {
                console.log('No valid children for:', menuItem.title);
                return false;
              }
            }
            // 如果是單一選單，檢查權限
            else if (menuItem.path) {
              const permission = pathToPermission[menuItem.path];
              if (permission) {
                const hasPermission = this.permissionStore.hasPermission(permission);
                console.log(`Permission check for ${menuItem.title}: ${permission} - ${hasPermission}`);
                if (!hasPermission) {
                  return false;
                }
              }
            }
          }

          // 3) 特殊檢查：提現功能
          if (menuItem.path === '/withdraw-funds' && user.withdraw_enabled !== true) {
            console.log('Withdraw check failed for:', menuItem.title);
            return false;
          }
          if (menuItem.path === '/card-payment' && user.pre_card_enabled !== true) {
            console.log('Card payment check failed for:', menuItem.title);
            return false;
          }

          console.log('Menu item passed all checks:', menuItem.title);
          return true;
        });

      console.log('Final filtered menu items:', filteredItems);
      return filteredItems;
    },

    layoutobject() {
      // 確保 layout.settings 已定義
      if (!this.layout || !this.layout.settings) return '';
      const layoutClass = layoutClasses.find(
        (item) => Object.keys(item).pop() === this.layout.settings.layout
      );
      return layoutClass
        ? layoutClass[this.layout.settings.layout]
        : '';
    },

    isUser() {
      const isAdminRoute = this.$route.path.startsWith('/admin');
      const user = JSON.parse(localStorage.getItem('Driver'));
      // 若路由不是 /admin 且確實有 Driver，則判斷為前台使用者
      if (!isAdminRoute && user) {
        return true;
      }
      return false;
    },

    isAdmin() {
      // 只在後台 Admin 時返回 true
      const admin = JSON.parse(localStorage.getItem('Admin'));
      
      // 檢查是否為 admin 角色且具有適當的權限
      const isAdminRole = admin && admin.role === 'admin';
      const hasAdminPermission = admin?.role_id && [1, 2].includes(admin.role_id); // 1: Super admin, 2: Admin
      
      return isAdminRole && hasAdminPermission;
    },

    // 檢查是否有 Settings 權限
    hasSettingsPermission() {
      const hasPermission = this.permissionStore.hasPermission('Settings');
      console.log('Settings permission check:', hasPermission);
      return hasPermission;
    },
  },

  methods: {
    // 根據權限過濾子選單（不修改原始資料）
    getVisibleChildren(menuItem) {
      if (!menuItem.children) return [];
      const user = this.currentUser;
      if (user && user.role === 'admin') {
        const pathToPermission = {
          '/admin/cash-payments': 'Payments & Transfers',
          '/admin/dashboard': 'Dashboard',
          '/admin/transactions': 'Transactions',
          '/admin/driver-profile': 'Driver profile',
          '/admin/subgroups': 'Subgroups',
          '/admin/terminal': 'Terminal',
          '/admin/terminal-performance': 'Terminal performance',
          '/admin/fees-charges': 'Fees & charges',
          '/admin/refunds': 'Refunds',
          '/admin/staff-members': 'Staff members',
          '/admin/fleet': 'Fleet',
          '/admin/settings': 'Settings',
          '/admin/role': 'Role',
          '/admin/card-application': 'Card',
          '/admin/card-management': 'Card',
          '/admin/card-performance': 'Card'
        };
        return menuItem.children.filter(child => {
          const permission = pathToPermission[child.path];
          if (permission) {
            return this.permissionStore.hasPermission(permission);
          }
          return true;
        });
      }
      return menuItem.children;
    },

    // 登出
    logout() {
      const currentRoute = this.$route.path;
      const driverToken = localStorage.getItem('driverToken');
      const adminToken = localStorage.getItem('adminToken');

      if (currentRoute.startsWith('/admin')) {
        // 後台登出
        if (adminToken) {
          localStorage.removeItem('Admin');
          localStorage.removeItem('adminToken');
          this.$router.replace('/admin/login');
        }
      } else {
        // 前台登出
        if (driverToken) {
          localStorage.removeItem('Driver');
          localStorage.removeItem('driverToken');
          this.$router.replace('/auth/login');
        }
      }
    },

    // 點選導航項
    setNavActive(item, event) {
      // 若使用者按下 Ctrl/Command + Click，則開新分頁而不改 active
      if (event.ctrlKey || event.metaKey) {
        return;
      }

      // 如果是子選單（sub），實現展開/收合功能
      if (item.type === 'sub') {
        // 如果已經展開，則收合
        if (item.active) {
          item.active = false;
          // 同時收合所有子項的 active 狀態
          if (item.children) {
            item.children.forEach((child) => (child.active = false));
          }
        } else {
          // 如果未展開，則展開
          item.active = true;
        }
        return;
      }

      // 對於 link 類型的選單項，清除所有 active 狀態
      this.menuItems.forEach((menuItem) => {
        menuItem.active = false;
        if (menuItem.children) {
          menuItem.children.forEach((child) => (child.active = false));
        }
      });

      // 若是子項，則將母項也設為激活
      if (item.type === 'link') {
        const parentItem = this.menuItems.find((menuItem) =>
          menuItem.children && menuItem.children.includes(item)
        );
        if (parentItem) {
          parentItem.active = true;
        }
      }

      // 設置當前項為激活
      item.active = true;
    },

    // 判斷某個菜單是否激活
    isMenuActive(menuItem) {
      if (menuItem.active) return true;
      if (menuItem.children) {
        return menuItem.children.some((child) => child.active);
      }
      return false;
    },

    // 判斷子菜單是否激活
    isChildActive(menuItem) {
      if (menuItem.children) {
        return menuItem.children.some((child) => child.active);
      }
      return false;
    },

    // 動態載入圖示
    getIconPath(icon) {
      try {
        return require(`@/assets/images/icon/${icon}.png`);
      } catch (e) {
        console.error(`Cannot find module for icon: ${icon}`);
        return '';
      }
    },

    // 根據當前路由設定激活項
    setActiveMenuByRoute() {
      const currentPath = this.$route.path;
      this.menuItems.forEach((menuItem) => {
        menuItem.active = menuItem.path === currentPath;
        if (menuItem.children) {
          menuItem.children.forEach((child) => {
            child.active = child.path === currentPath;
            if (child.active) {
              menuItem.active = true;
            }
          });
        }
      });
    },

    // 初始化權限
    async initPermissions() {
      const user = this.currentUser;
      const admin = JSON.parse(localStorage.getItem('Admin'));
      
      console.log('Initializing permissions for user:', user);
      console.log('Admin data:', admin);
      
      if (user && admin && admin.role_id) {
        console.log('Fetching permissions for role_id:', admin.role_id);
        await this.permissionStore.fetchPermissions(admin.role_id);
        console.log('Permissions fetched:', this.permissionStore.permissions);
      } else {
        console.log('Cannot initialize permissions - missing required data');
      }
    }
  },

  async mounted() {
    // 組件掛載後檢查當前路由，設定對應的菜單項激活
    this.setActiveMenuByRoute();
    // 初始化權限
    await this.initPermissions();
    console.log('Component mounted, permissions initialized');
  },

  watch: {
    $route() {
      // 路由改變時，重新設定激活項
      this.setActiveMenuByRoute();
    },
  },
};
</script>

<style scoped>
.sidebar-links {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow-y: auto;
}

.sidebar-link {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  transition: background-color 0.3s ease, color 0.3s ease;
  position: relative;
}

/* active 狀態的背景顏色及文字顏色 */
.sidebar-list.active .sidebar-link,
.sidebar-list.active .sidebar-link span,
.sidebar-submenu .active .lan-4,
.sidebar-submenu .active .lan-4 span {
  background-color: #ccf4e0 !important; /* 背景顏色 */
  color: #000 !important; /* 文字顏色 */
}

/* 僅在母項目 active 且子項目未激活時顯示書簽 */
.sidebar-list.active:not(.active-child) .sidebar-link::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 5px; /* 書簽的寬度 */
  background-color: #06fe7f; /* 書簽的顏色 */
  z-index: 1; /* 確保書簽位於最上層 */
}

/* 在子項目 active 時顯示書簽 */
.sidebar-submenu .active .lan-4::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 5px; /* 書簽的寬度 */
  background-color: #06fe7f; /* 書簽的顏色 */
  z-index: 1; /* 確保書簽位於最上層 */
}

/* 確保背景色在書簽下方 */
.sidebar-list.active .sidebar-link,
.sidebar-submenu .active .lan-4 {
  z-index: 0; /* 背景色保持在書簽下方 */
}

/* hover 狀態的背景顏色及文字顏色，確保與 active 顏色一致 */
.sidebar-link:hover,
.sidebar-link:hover span,
.sidebar-submenu .lan-4:hover,
.sidebar-submenu .lan-4:hover span {
  background-color: #ccf4e0 !important; /* 背景顏色 */
  color: #000 !important; /* 文字顏色 */
}

/* 移除子選單項目前的橫線 */
.sidebar-submenu .lan-4::after {
  display: none !important;
}

.sidebar-bottom {
  margin-top: auto;
  padding-bottom: 20px;
  margin-bottom: 20px;
  font-size: 16px;
}

.stroke-icon,
.fill-icon {
  width: 24px;
  height: 24px;
  margin-right: 10px;
}

.footer-icon {
  font-size: 24px;
}

.help-icon {
  height: 30px;
  width: 30px;
}

.text-default {
  border: 2px solid black;
  border-radius: 50%;
  color: #06fe7f;
}

.new-icon {
  width: 42px;
  height: 20px;
  margin-left: 10px;
}

.overview,
.payments,
.profile,
.reports,
.withdraw,
.card-payment {
  width: 40px;
  height: 40px;
  margin-right: 10px;
}
.prev-icon {
  width: 10px;
  height: 15px;
  transform: rotate(180deg);
  transition: transform 0.3s ease;
}

.prev-icon.rotated {
  transform: rotate(270deg);
}
</style>
